export default "__VITE_ASSET__e61726e7__"